import axios, {
  AxiosRequestConfig,
  AxiosResponse,
  Canceler,
  CancelToken
} from "axios";
const service = axios.create({
  baseURL: "/api",
  timeout: 5000,
  headers: {
    "Content-Type": "application/json"
  }
});

// // 前端防抖
// export interface IOnService {
//   url: string;
//   cancel: Canceler;
// }

// export interface ICancelAxios {
//   registerService<T extends AxiosRequestConfig>(config: T): T;
//   removeService(response: AxiosResponse): AxiosResponse;
// }

// class CancelAxios implements ICancelAxios {
//   private onServices: IOnService[] = [];

//   public removeService(response: AxiosResponse<any>): AxiosResponse<any> {
//     const index = _.findIndex(this.onServices, (onService: IOnService) => onService.url === response.config.url);
//     if (index !== -1) {
//       this.onServices[index].cancel();
//       _.pullAt(this.onServices, index);
//     }
//     return response;
//   }

//     /**
//      * @param config axios请求设置
//      */
//   public registerService<T extends AxiosRequestConfig>(config: T): T {
//     const index: number = _.findIndex(this.onServices, (onService: IOnService): boolean => onService.url === config.url);
//     if (index === -1) {
//       const currentService = <IOnService>{};
//       config.cancelToken = new axios.CancelToken((canceler: Canceler) => {
//         currentService.cancel = canceler;
//         currentService.url = config.url ? config.url : '';
//       });
//       this.onServices.push(currentService);
//     } else {
//       const currentService = this.onServices[index];
//       currentService.cancel();
//       config.cancelToken = new axios.CancelToken((canceler: Canceler) => {
//         currentService.cancel = canceler;
//       });
//     }
//     return config;
//   }
// }

export default service;
